import { ReservationActionName } from '~/components/System/ReservationRemediation/types';

import { diffDays, formatDateShort } from '~/services/TimeService';

export const BEDBANK_QUEUE_ACTION_MAP: Record<string, ReservationActionName> = {
  confirm_booking: ReservationActionName.Commit,
  cancel_booking: ReservationActionName.Cancel,
};

export const getActionNameForQueue = (queueName?: string | null): ReservationActionName | undefined => {
  if (!queueName) {
    return undefined;
  }

  return BEDBANK_QUEUE_ACTION_MAP[queueName];
};

interface PasteableDetails {
  actionLabel: string;
  orderLink?: string | null;
  bookingNumber?: string | null;
  channelManager?: string | null;
  fallbackId?: string | null;
  isTestAccount?: boolean;
  checkInDate?: Date | null;
}

export const buildPasteableText = ({
  actionLabel,
  orderLink,
  bookingNumber,
  channelManager,
  fallbackId,
  isTestAccount,
  checkInDate,
}: PasteableDetails) => {
  const parts = [actionLabel];

  if (orderLink) {
    parts.push(orderLink);
  } else if (fallbackId) {
    parts.push(fallbackId);
  }

  if (bookingNumber) {
    parts.push(bookingNumber);
  }

  if (channelManager) {
    parts.push(channelManager);
  }

  let pasteable = parts.join(' ');

  if (isTestAccount) {
    pasteable += ' - [Test Account]';
  }

  if (checkInDate) {
    const leadTime = diffDays(checkInDate, new Date());
    if (leadTime < 10) {
      pasteable += ` ⏰ Checking in soon! ${formatDateShort(checkInDate)}`;
    }
  }

  return pasteable;
};
